import { ChangeDetectionStrategy, Component, inject, signal } from '@angular/core';
import {
  MatDialogRef,
  MAT_DIALOG_DATA,
  MatDialogTitle,
  MatDialogContent,
  MatDialogActions,
} from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';

@Component({
  selector: 'app-session-expiry-dialog',
  changeDetection: ChangeDetectionStrategy.OnPush,
  styleUrl: './session-expiry-dialog.component.scss',
  template: `
    <div class="session-expiry-dialog">
      <h2 matDialogTitle class="dialog-title">
        <mat-icon class="warning-icon">warning</mat-icon>
        Session Expired
      </h2>

      <div matDialogContent class="dialog-content">
        <p>{{ message() }}</p>
      </div>

      <div matDialogActions class="dialog-actions" align="end">
        <button mat-raised-button color="primary" (click)="onOk()">OK</button>
      </div>
    </div>
  `,
  imports: [MatDialogTitle, MatDialogContent, MatDialogActions, MatButtonModule, MatIconModule],
})
export class SessionExpiryDialogComponent {
  private readonly dialogRef = inject(MatDialogRef<SessionExpiryDialogComponent>);
  private readonly data = inject<{ message: string }>(MAT_DIALOG_DATA);

  readonly message = signal(this.data.message || 'Your session has expired.');

  constructor() {
    this.dialogRef.disableClose = true;
  }

  onOk(): void {
    this.dialogRef.close('logout');
  }
}
